import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CROSS } from 'src/defaultImages.js';
import { LocalStorageService } from '../../services/localStorage.service';

@Component({
  selector: 'app-lhdn-modal',
  templateUrl: './lhdn-modal.component.html',
  styleUrls: ['./lhdn-modal.component.css']
})
export class LhdnModalComponent {
  images = {
    CROSS: CROSS,
  };  
  constructor(private dialogRef: MatDialogRef<any>, private _localStorage: LocalStorageService){}
  cancel_clicked() {
    this.dialogRef.close({ data: 'closed' });
  }
  alreadyFilled(){
    this._localStorage.set('lhdn_form_filled', 1);
    this.dialogRef.close({ data: 'lhdn_form_filled' });
  }
}
